export default __webpack_public_path__ + "static/media/Timeworn Gloves.ce0fd6bc.jpg";